
export const setIsTesting = () => {
    return {
        type: 'SET_IS_TESTING',
        payload: true
    };
};
